import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Typography, Button } from '@mui/material'
import React from 'react'
import { TokenRecoveryType } from '../../../interfaces/enum/TokenRecoveryType'
import { sxTypographyTitle, sxButtonOptionRecovery } from '../sxProps'
import { OptionsRecoveryProps } from '../../../interfaces/props/passwordRecovery/OptionsRecoveryProps'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext'

const OptionsRecovery: React.FC<OptionsRecoveryProps> = ({ formBack, openTokenReceived,openQuestionsToRecoveryPassword }) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();
  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitle} className='margin-bottom-painel-rigth'>Redefinir senha</Typography>
        </div>
        <div className='container-text-recovery '>
          <span style={textStyleAccessibility} className='login-text login-text-center'>Escolha abaixo por onde quer receber o seu token de acesso para o canal do cliente.</span>
        </div>
      </div>
      <div className='container-recovery-password-options'>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => openTokenReceived(TokenRecoveryType.Email)} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>RECEBER TOKEN POR EMAIL</Typography>
        </Button>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => openTokenReceived(TokenRecoveryType.SMS)} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>RECEBER TOKEN POR SMS</Typography>
        </Button>
        <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => openQuestionsToRecoveryPassword()} variant='contained'>
          <Typography style={buttonTextStyleAccessibility}>RESPONDER QUESTIONÁRIO</Typography>
        </Button>
      </div>
    </div>
  )
}

export default OptionsRecovery